import React from 'react'

import dontShootFilms from '../../images/DONT_SHOOT_FILMS.png'
import dontShootFilms2 from '../../images/DONT SOOT FILMS 2.JPG'
import dontShootFilms3 from '../../images/DONT SHOOT FILMS 3.JPG'
import dontShootFilms4 from '../../images/DONT SHOOT FILMS 3.png'
import dontShootFilms5 from '../../images/DONT SHOOT FILMS.jpg'

function DontShootFilms() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={dontShootFilms}
            className="project-image" />
          <img
            src={dontShootFilms2}
            className="project-image" />
          <img
            src={dontShootFilms4}
            className="project-image" />
          <img
            src={dontShootFilms5}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>DON'T SHOOT FILMS</h1>
          <p className="Project-text">
            <strong>
              CEO's:
            <br />
              Ella Gilbert
            <br />
              Samuel Austin
            <br />
              Frankie Berge
            <br />
              <br />
              Collective:
            <br />
              Ivo Deliyski
            <br />
              Grace Bentley Tsibuah
            <br />
              Ella Hope Higginson
            <br />
              Tim Earl
            </strong>
          </p>
          <p className="Project-testimonial">
            Awards:
            <br />
            WINNER
            Grand Prize / 1st Place, Super8x8 Film Competition, 2019 - Don’t Shoot Films
            <br />
            WINNER
            Monster Valley Arthouse Award, Super8x8 Film Competition, 2018 - Don’t Shoot Films
            <br />
            TOP 20 FILMS
            London Straight8 Film Competition, 2018, 2019 and 2020 - Don’t Shoot Films
          </p>
          <p className="Project-text">
            Aotearoa film collective Don’t Shoot Films was founded in 2017. A company of multi-faceted artists and friends who love to work on Super8mm film. Their robust collaboration and interest in absurd, surreal, guerilla style movie making produces unique and impactful work.
            <br />
            They are currently completing a funded 6 part series of short films, in competition for London film festival Straight8 AND in pre production for new scripted short ‘Mary Mary’
          </p>
        </div>
      </div>
    </div>
  )
}

export default DontShootFilms
